import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Message } from 'semantic-ui-react';
import TokensTable from '../../components/TokensTable';
import { useTranslation } from 'react-i18next';

const Token = () => {
  const { t } = useTranslation();

  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>{t('token.title')}</Card.Header>
          <Message info>
            {t('token.list.hint')}{' '}
            <Link to='/model-rates' style={{ color: '#00ff85' }}>
              {t('token.edit.scope_tier.link_rates')}
            </Link>
            {' · '}
            <Link to='/plans' style={{ color: '#00ff85' }}>
              {t('token.edit.scope_tier.link_plans')}
            </Link>
          </Message>
          <TokensTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default Token;
